/** @format */

const { createPlugin } = require("fusion-core");
const fetch = require("node-fetch");
const axios = require("axios");
const {
  QUOTE_API_URL,
  INSURANCE_API_URL,
  QUOTE_API_SESSION_COOKIE,
  BUY_API_URL,
  MJ_APIKEY_PUBLIC,
  MJ_APIKEY_PRIVATE,
  MJ_FROM_ADDRESS,
  MJ_TO_CLAIMS,
  MJ_TO_SUPPORT,
} = __NODE__ && require("./config/config");
const { TAXI_QUOTE_BRANDREF } = __NODE__ && require("../src/config/config");
const cookie = require("cookie");
const brandRef = TAXI_QUOTE_BRANDREF;
const { renderSupportEmail, renderSupportText } = require("./features/portal/pages/support/supportEmailTemplate");
const quoteApiUrl = QUOTE_API_URL;
const buyApiUrl = BUY_API_URL;
const insuranceApiUrl = INSURANCE_API_URL;

let cachedToken = null;
let tokenExpirationTime = null;

const getToken = () => {
  return Date.now() < tokenExpirationTime ? cachedToken : null;
};

const setToken = (token, expiration) => {
  cachedToken = token;
  tokenExpirationTime = expiration;
};

const fetchToken = async () => {
  if (__BROWSER__) return;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization:
      "Basic MG9hZWJ6cTFsZzBTd1I1TlA2OTc6N1J5UHRGMllyYmYxWWRGQnp3RzB2dVAyd3BnSVQxMUFjQnpBZl9uOEl3RmRGdTJILUlNSm9pZGM3Q1E3QnJhTw==",
  };

  const body = new URLSearchParams({
    grant_type: "client_credentials",
    scope: "uber.frontend",
  });

  try {
    const response = await fetch(
      "https://freewayins.okta.com/oauth2/default/v1/token",
      {
        method: "POST",
        headers,
        body,
      }
    );

    const result = await response.json();
    const expiration = Date.now() + 30 * 60 * 1000;
    setToken(result.access_token, expiration);
  } catch (error) {
    throw new Error("Failed to fetch token");
  }
};

const ensureToken = async () => {
  let token = getToken();
  if (!token) {
    await fetchToken();
    token = getToken();
  }
  return token;
};

const parseRequestBody = (ctx) => {
  return new Promise((resolve, reject) => {
    let data = "";
    ctx.req.on("data", (chunk) => (data += chunk));
    ctx.req.on("end", () => {
      try {
        resolve(JSON.parse(data));
      } catch (err) {
        reject(err);
      }
    });
  });
};

const setCookieHeader = (ctx, cookies) => {
  ctx.set("Set-Cookie", cookies);
};

const createCookieString = (name, value, options = {}) => {
  return cookie.serialize(name, value, {
    httpOnly: true,
    secure: true,
    sameSite: "strict",
    ...options,
  });
};

const fetchApi = async (url, method = "get", body, headers = {}) => {
  const token = await ensureToken();
  try {
    const defaultHeaders = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
      // Added Accept header
      ...headers,
    };

    let options = {};
    if (body) {
      options = {
        method,
        url,
        maxBodyLength: Infinity,
        headers: defaultHeaders,
        data: body,
      };
    } else {
      options = {
        method,
        maxBodyLength: Infinity,
        url,
        headers: defaultHeaders,
      };
    }

    const response = await axios.request(options);

    if (!response.status || response.status >= 400) {
      const errorDetails = response.data
        ? response.data
        : "No additional error details available.";
      throw new Error(
        `Something went wrong! Status: ${response.status}. ${
          typeof errorDetails === "object"
            ? JSON.stringify(errorDetails)
            : errorDetails
        }`
      );
    }

    const custom = new Headers(response.headers);

    const setCookies = custom.getSetCookie();
    const aspCookie = setCookies.filter((str) =>
      str.includes(`${QUOTE_API_SESSION_COOKIE}=`)
    );

    let temp = response.data;

    temp.aspCookie = aspCookie ? aspCookie[0] : "";
    return temp;
  } catch (error) {
    console.error("error at fetchAPI", error);
    throw error;
  }
};

const apiRoutes = {
  "/api/make": {
    url: `${quoteApiUrl}/api/quote/list/simple/pv_make/${brandRef}`,
    method: "get",
  },
  "/api/model": {
    url: `${quoteApiUrl}/api/quote/list/advanced`,
    method: "get",
  },
  "/api/vehicleBodyType": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_body_type/ditxweb`,
    method: "get",
  },
  "/api/occupation": {
    url: `${quoteApiUrl}/api/quote/list/simple/occupation/${brandRef}`,
    method: "get",
  },
  "/api/martial-status": {
    url: `${quoteApiUrl}/api/quote/list/simple/marital_status/${brandRef}`,
    method: "get",
  },
  "/api/address-lookup": {
    url: `${quoteApiUrl}//api/quote/lookup/address`,
    method: "get",
  },
  "/api/vehiclemod": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_mod/${brandRef}`,
    method: "get",
  },
  "/api/manualVehicle": {
    url: `${quoteApiUrl}/api/quote/lookup/vehicles`,
    method: "get",
  },
  "/api/VehicleReg": {
    url: `${quoteApiUrl}/api/quote/lookup/vehicle`,
    method: "get",
  },
  "/api/uberBranch": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_incvalrn/${brandRef}`,
    method: "get",
  },
  "/api/employmentStatus": {
    url: `${quoteApiUrl}/api/quote/list/simple/employment_status/${brandRef}`,
    method: "get",
  },
  "/api/employersBus": {
    url: `${quoteApiUrl}/api/quote/list/simple/employers_bus/${brandRef}`,
    method: "get",
  },
  "/api/keeper": {
    url: `${quoteApiUrl}/api/quote/list/simple/keeper/${brandRef}`,
    method: "get",
  },
  "/api/owner": {
    url: `${quoteApiUrl}/api/quote/list/simple/ownership/${brandRef}`,
    method: "get",
  },
  "/api/volentryExcess": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_excess/${brandRef}`,
    method: "get",
  },
  "/api/licenceAuth": {
    url: `${quoteApiUrl}/api/quote/list/simple/taxi_area/${brandRef}`,
    method: "get",
  },
  "/api/vehicleclm": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_clm_type/${brandRef}`,
    method: "get",
  },
  "/api/securityDevice": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_alarm/${brandRef}`,
    method: "get",
  },
  "/api/rating": {
    url: `${quoteApiUrl}/api/quote/list/simple/company_car_use/${brandRef}`,
    method: "get",
  },
  "/api/vehicleUse": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_use/${brandRef}`,
    method: "get",
  },
  "/api/relationship": {
    url: `${quoteApiUrl}/api/quote/list/simple/relationship/${brandRef}`,
    method: "get",
  },
  "/api/overNight": {
    url: `${quoteApiUrl}/api/quote/list/simple/overnight/${brandRef}`,
    method: "get",
  },
  "/api/vehCover": {
    url: `${quoteApiUrl}/api/quote/list/simple/vehicle_cover/${brandRef}`,
    method: "get",
  },
  "/api/panel": {
    url: `${quoteApiUrl}/api/quote/panel`,
    method: "get",
  },
  "/api/newQuote": {
    url: `${quoteApiUrl}/api/quote/new`,
    method: "get",
  },
  "/api/recommendations": {
    url: `${quoteApiUrl}/api/quote/addon/recommendations`,
    method: "get",
  },
  "/api/optional": {
    url: `${quoteApiUrl}/api/quote/addon/optional`,
    method: "get",
  },
  "/api/retriveQuote": {
    url: `${quoteApiUrl}/api/quote/retrieverisk`,
    method: "get",
  },
  "/api/quote/save": {
    url: `${quoteApiUrl}/api/quote/save`,
    method: "post",
  },
  "/api/ConvertQuoteIntopolicy": {
    url: `${buyApiUrl}/api/buy/nb/convert`,
    method: "post",
  },
  "/api/pclAgreementurl": {
    url: `${buyApiUrl}/api/buy/pcl/agreementurl`,
    method: "post",
  },
  "/api/payment/options": {
    url: `${quoteApiUrl}/api/quote/payment/options`,
    method: "get",
  },
  "/api/paymentReqJson": {
    url: `${buyApiUrl}/api/buy/paymentrequestjson`,
    method: "get",
  },
  "/api/manualVehicles": {
    url: `${quoteApiUrl}/api/quote/lookup/vehicles`,
    method: "get",
  },
  "/api/titles-with-gender": {
    url: `${quoteApiUrl}/api/quote/list/advanced`,
    method: "get",
  },
  "/api/ncd": {
    url: `${quoteApiUrl}/api/quote/list/advanced`,
    method: "get",
  },
  "/api/save/member": {
    url: `${quoteApiUrl}/api/quote/panel/save/member`,
    method: "post",
  },
  "/api/quote/risk": {
    url: `${quoteApiUrl}/api/quote/risk`,
    method: "get",
  },
  "/api/quote/clone": {
    url: `${quoteApiUrl}/api/quote/clone`,
    method: "get",
  },
  "/portal/login": {
    url: `${insuranceApiUrl}/api/insurance/portal/login`,
    method: "get",
  },
  "/getPolicies": {
    url: `${insuranceApiUrl}/api/insurance/getpolicieslist`,
    method: "get",
  },
  "/api/postCase": {
    url: `${insuranceApiUrl}/api/insurance/portal/customer/case`,
    method: "post",
  },
  "/api/customerPolicies": {
    url: `${insuranceApiUrl}/api/insurance/portal/customer/policies/list`,
    method: "get",
  },
  "/api/customerQuotes": {
    url: `${insuranceApiUrl}/api/insurance/portal/customer/quotes/current`,
    method: "get",
  },
  "/api/generateDocuments": {
    url: `${insuranceApiUrl}/api/vault/generate/documents`,
    method: "post",
  },
  "/api/template/list": {
    url: `${insuranceApiUrl}/api/vault/template/list`,
    method: "get",
  },
  "/api/archive/list": {
    url: `${insuranceApiUrl}/api/vault/archive/list`,
    method: "get",
  },
  "/api/getDocumentDownloadURL": {
    url: `${insuranceApiUrl}`,
    method: "get",
  },
  "/api/getDocumentAddonDownloadURL": {
    url: `${insuranceApiUrl}`,
    method: "post",
  },
  "/api/resetCustomer": {
    url: `${insuranceApiUrl}/api/insurance/portal/login/refresh`,
    method: "get",
  },
};

const apiMiddleware = async (ctx, next) => {
  // Security Headers (Server-only)
  if (ctx.set) {
    ctx.set("Strict-Transport-Security", "max-age=31536000; includeSubDomains");
    ctx.set("X-Frame-Options", "SAMEORIGIN");
    const apiMiddleware = async (ctx, next) => {
      if (ctx.set) {
        ctx.set(
          "Strict-Transport-Security",
          "max-age=31536000; includeSubDomains"
        );
        ctx.set("X-Frame-Options", "SAMEORIGIN");

        ctx.set(
          "Content-Security-Policy",
          "default-src 'self'; " +
            "script-src 'self' 'unsafe-inline' " +
            "https://talkdeskchatsdk.talkdeskapp.com " +
            "https://www.googletagmanager.com " +
            "https://cdn.jsdelivr.net " +
            "https://code.jquery.com " +
            "https://*.hotjar.com; " +
            "connect-src 'self' " +
            "https://*.talkdeskapp.com " +
            "https://www.google-analytics.com " +
            "https://sentry.io " +
            "https://*.hotjar.com " +
            "wss://*.hotjar.com; " +
            "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; " +
            "font-src 'self' data: https://fonts.gstatic.com; " +
            "img-src 'self' data: https:; " +
            "frame-src 'self' https://*.talkdesk.com https://*.talkdeskapp.com https://www.youtube.com; " +
            "object-src 'none'; " +
            "base-uri 'self';"
        );
      }
      await next();
    };
  }

  if (ctx.path === "/api/sendEmail" && ctx.method === "POST") {
    const { requestBody, type } = await parseRequestBody(ctx);
    const subject =
      type === "claim"
        ? "Claim"
        : requestBody.Type === "Cancel and Existing Policy"
        ? "Cancellation"
        : "MTA";
    const toEmail = type === "claim" ? MJ_TO_CLAIMS : MJ_TO_SUPPORT;

    // Prepare inline attachments
    const inlinedAttachments = [];
    if (requestBody.attachments && requestBody.attachments.length > 0) {
      requestBody.attachments.forEach((att, index) => {
        if (att.base64Content) {
          inlinedAttachments.push({
            ContentType: att.type,
            Filename: att.name,
            ContentID: `attachment-${index}`,
            Base64Content: att.base64Content,
          });
        }
      });
    }

    const emailData = {
      Messages: [
        {
          From: {
            Email: MJ_FROM_ADDRESS,
            Name: "Freeway Insurance",
          },
          To: [
            {
              Email: toEmail,
              Name: type === "claim" ? "Claims Team" : "Support Team",
            },
          ],
          Subject: subject,
          TextPart:
            type === "support"
              ? renderSupportText(requestBody)
              : `New ${subject} request submitted. Details: ${JSON.stringify(
                  (() => {
                    const { attachments, ...rest } = requestBody;
                    return rest;
                  })(),
                  null,
                  2,
                )}`,
          HTMLPart: type === "support" ? renderSupportEmail(requestBody) : `<h3>New ${subject} Request</h3><p>Details: <pre style="font-size: 14px; line-height: 1.5;">${JSON.stringify(
            (() => {
              const { attachments, ...rest } = requestBody;
              return rest;
            })(),
            null,
            2,
          )}</pre></p>${
            inlinedAttachments.length > 0
              ? `<h4>Images:</h4>${inlinedAttachments
                  .map(
                    (att, index) =>
                      `<img src="cid:attachment-${index}" alt="${att.Filename}" style="max-width: 300px; margin: 10px;" />`
                  )
                  .join("")}`
              : ""
          }`,
          InlinedAttachments: inlinedAttachments,
        },
      ],
    };
    try {
      const response = await fetch("https://api.mailjet.com/v3.1/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${Buffer.from(
            `${MJ_APIKEY_PUBLIC}:${MJ_APIKEY_PRIVATE}`
          ).toString("base64")}`,
        },
        body: JSON.stringify(emailData),
      });
      if (!response.ok) {
        throw new Error(`Email send failed: ${response.status}`);
      }
      const result = await response.json();
      ctx.body = { success: true, result };
    } catch (error) {
      ctx.status = 500;
      ctx.body = { error: error.message };
    }
    return;
  }

  const apiRoute = apiRoutes[ctx.path];
  if (apiRoute) {
    try {
      const { url, method } = apiRoute;
      let body = null;

      if (ctx.request.method !== "GET") {
        body = await parseRequestBody(ctx);
      }

      let data = "";

      if (Object.keys(ctx.query).length > 0) {
        const queryParams = Object.values(ctx.query)
          .map(encodeURIComponent)
          .join("/");
        const baseUrl = `${url}/${queryParams}`;
        if (
          ctx.path == "/getPolicies" ||
          ctx.path == "/portal/login" ||
          ctx.path == "/api/paymentReqJson" ||
          ctx.path == "/api/pclAgreementurl" ||
          ctx.path == "/api/ConvertQuoteIntopolicy" ||
          ctx.path == "/api/customerPolicies" ||
          ctx.path == "/api/getDocumentDownloadURL"
        ) {
          data = await fetchApi(baseUrl, method, body);
        } else {
          data = await fetchApi(baseUrl, method, body, {
            Cookie: ctx?.request?.headers?.cookie ?? "",
          });
        }
      } else {
        if (
          ctx.path == "/getPolicies" ||
          ctx.path == "/portal/login" ||
          ctx.path == "/api/paymentReqJson" ||
          ctx.path == "/api/pclAgreementurl" ||
          ctx.path == "/api/ConvertQuoteIntopolicy" ||
          ctx.path == "/api/customerPolicies" ||
          ctx.path == "/api/getDocumentDownloadURL"
        ) {
          data = await fetchApi(url, method, body);
        } else {
          data = await fetchApi(url, method, body, {
            Cookie: ctx?.request?.headers?.cookie ?? "",
          });
        }
      }
      if (data?.aspCookie) {
        const newCookie = createCookieString(
          QUOTE_API_SESSION_COOKIE,
          cookie.parse(data?.aspCookie)[QUOTE_API_SESSION_COOKIE],
          {
            maxAge: 60 * 10,
            path: "/",
            secure: true,
            httpOnly: true,
            sameSite: "lax",
          }
        );

        setCookieHeader(ctx, newCookie);
      }

      ctx.body = data;
    } catch (error) {
      if (error?.response?.data) {
        ctx.body = error.response.data;
        console.error("error.data", ctx.body);
      } else {
        // Mask stack trace in production
        ctx.body = { error: "An unexpected error occurred." };
        console.error(error, "error");
      }

      if (error?.response?.status) {
        ctx.status = error.response.status;
      } else {
        ctx.status = 500;
      }
    }
  } else {
    await next();
  }
};

const combinedPlugin = createPlugin({
  middleware: () => apiMiddleware,
});

module.exports = combinedPlugin;
